import { DocumentTagger } from 'features/files'
import { FC, useCallback } from 'react'

import { NiiViewContainer } from './components/NiiViewContainer'
import { NiiViewProps } from './NiiDetailsModal'

const DEFAULT_KEYS = [
  'commission_date',
  'design_code',
  'contents',
  'external_coating',
  'insulation',
  'design_pressure_bar',
  'operating_pressure_bar',
  'design_temperature_c',
  'max_operating_temperature_c',
  'internal_inspection_interval_yrs',
  'next_internal_inspection',
  'material',
  'geometry',
  'length_mm',
  'height_mm',
  'internal_diameter_mm',
  'external_diameter_mm',
  'total_surface_area_sq_m',
  'wall_thickness_shell_mm',
  'wall_thickness_heads_mm',
  'corrosion_allowance_mm',
]

export const NiiDocumentTaggingView: FC<NiiViewProps> = ({ unitEntry }) => {
  const handleTaggingComplete = useCallback(() => {}, [])

  const handleTaggingError = useCallback((error: string) => {
    console.error('Document tagging failed:', error)
  }, [])

  return (
    <NiiViewContainer
      title='Tag Documents'
      description='Add key-value pairs to tag documents uploaded for this NII assessment. These tags will help organize and categorize the supporting documentation.'>
      <DocumentTagger
        entry={unitEntry}
        onComplete={handleTaggingComplete}
        onError={handleTaggingError}
        defaultKeys={DEFAULT_KEYS}
      />
    </NiiViewContainer>
  )
}
